'use client';

import AppLayout from '@/components/AppLayout';
import FriendsContent from './components/FriendsContent';

export default function FriendsPage() {
  return (
    <AppLayout>
      <FriendsContent />
    </AppLayout>
  );
}
